import { useState, useEffect } from "react";
import { Phone } from "lucide-react";
import { SITE } from "../data/site";
import { WhatsAppIcon } from "./Header";

const StickyMobileCTA = () => {
    const [visible, setVisible] = useState(false);
    useEffect(() => {
        const onScroll = () => {
            const pct = (window.scrollY / Math.max(1, document.body.scrollHeight - window.innerHeight)) * 100;
            setVisible(pct > 30);
        };
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    if (!visible) return null;
    return (
        <div
            className={`md:hidden fixed bottom-0 inset-x-0 z-[75] bg-navy border-t border-gold/30 grid grid-cols-2 pb-[env(safe-area-inset-bottom)] animate-[slideUp_.3s_ease-out]`}
            data-testid="sticky-mobile-cta"
        >
            <a href={SITE.phoneHref} className="flex items-center justify-center gap-2 py-3.5 text-white font-semibold text-sm" data-testid="sticky-call-button">
                <Phone className="w-4 h-4 text-gold" /> Call Now
            </a>
            <a href={SITE.whatsapp} target="_blank" rel="noopener noreferrer" className="flex items-center justify-center gap-2 py-3.5 bg-[#25D366] text-white font-semibold text-sm" data-testid="sticky-whatsapp-button">
                <WhatsAppIcon className="w-4 h-4" /> WhatsApp
            </a>
        </div>
    );
};

export default StickyMobileCTA;
